import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from './contexts/ThemeContext.tsx';
import { initSentry } from './config/sentry';
import App from './App.tsx';
import i18n from './i18n/config';
import './index.css';
import './utils/consoleOverride';

// Initialize Sentry
initSentry();

// Create QueryClient for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 2,
      staleTime: Number(import.meta.env.VITE_QUERY_STALE_TIME) || 300000, // Default: 5 minutes
      gcTime: Number(import.meta.env.VITE_QUERY_GC_TIME) || 300000, // Default: 5 minutes
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
          <App />
        </ThemeProvider>
      </I18nextProvider>
    </QueryClientProvider>
  </StrictMode>
);
